import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'FUNDAMENTOS, SEGURIDAD Y DIAGNÓSTICO',
  desc: 'El Protocolo Cero Riesgo de 5 pasos. Herramientas esenciales. El lenguaje de los cables. Tu primera reparación real sin riesgos.',
  color: 'text-blue-400',
  bg: 'bg-blue-400/10'
}, {
  num: '2',
  title: 'CIRCUITOS, ILUMINACIÓN Y CABLEADO',
  desc: 'Fundamentos de circuitos. Sistemas de iluminación LED. Los 4 tipos de llaves de luz. Instalación de un punto de luz nuevo.',
  color: 'text-green-400',
  bg: 'bg-green-400/10'
}, {
  num: '3',
  title: 'ENCHUFES, TOMAS Y CONEXIONES',
  desc: 'Cambio de módulos. Tomas de alta potencia. Conexiones correctas en cocina y baño. Todo con protocolo de seguridad incluido.',
  color: 'text-orange-400',
  bg: 'bg-orange-400/10'
}, {
  num: '4',
  title: 'TABLEROS Y PROTECCIONES',
  desc: 'Anatomía del tablero. Térmicas, diferenciales y DPS. Cómo agregar una térmica. El tablero perfectamente organizado y etiquetado.',
  color: 'text-red-400',
  bg: 'bg-red-400/10'
}, {
  num: '5',
  title: 'INSTALACIONES ESPECIALES Y EXTERIOR',
  desc: 'Circuito del aire acondicionado. Termotanque. Iluminación exterior. Cargador de auto eléctrico. Energía solar doméstica.',
  color: 'text-purple-400',
  bg: 'bg-purple-400/10'
}, {
  num: '6',
  title: 'EL DIAGNOSTICADOR PROFESIONAL',
  desc: 'El método de los técnicos senior. Mediciones avanzadas. Mantenimiento preventivo anual. Auditoría técnica total de tu hogar.',
  color: 'text-gold',
  bg: 'bg-gold/10'
}];
const inclusions = ['Contenido 100% listo — abrís el PDF y empezás', 'Protocolos de seguridad en cada procedimiento', 'Checklists, tablas de referencia y planillas', 'Diseñado para el hogar argentino'];
export function TomosSection() {
  return <section className="py-14 bg-petroleum/30 border-y border-electric/10" data-id="element-298">
      <div className="container mx-auto px-4" data-id="element-299">
        <div className="text-center mb-10" data-id="element-300">
          <div className="inline-flex items-center gap-2 text-gold font-bold tracking-widest uppercase text-sm mb-4" data-id="element-301">
            <span className="w-8 h-px bg-gold" data-id="element-302"></span>
            El Sistema Completo
            <span className="w-8 h-px bg-gold" data-id="element-303"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-304">
            🏆 ELECTRICIDAD EN CASA:
            <br data-id="element-305" />
            <span className="text-electric" data-id="element-306">EL SISTEMA CERO RIESGO</span>
          </h2>
          <p className="text-xl text-textsecondary" data-id="element-307">
            6 Tomos + 6 Bonos — De 0 a Diagnosticador Profesional ·{' '}
            <span className="text-white font-bold" data-id="element-308">
              300+ páginas. Todo resuelto.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-309">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum rounded-2xl p-6 border border-white/5 hover:border-electric/30 transition-all group relative overflow-hidden" data-id="element-310">
              <div className={`absolute top-0 right-0 w-32 h-32 ${tomo.bg} blur-3xl rounded-full -mr-10 -mt-10 transition-opacity group-hover:opacity-100 opacity-50`} data-id="element-311"></div>

              <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-312">
                <div className={`w-12 h-12 rounded-xl ${tomo.bg} ${tomo.color} flex items-center justify-center font-bold text-xl`} data-id="element-313">
                  {tomo.num}
                </div>
                <BookOpen className={`w-6 h-6 ${tomo.color} opacity-50`} data-id="element-314" />
              </div>

              <h3 className="text-lg font-bold mb-3 relative z-10" data-id="element-315">
                Tomo {tomo.num} — {tomo.title}
              </h3>
              <p className="text-textsecondary text-sm leading-relaxed relative z-10" data-id="element-316">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-graphite rounded-2xl p-8 border border-electric/20" data-id="element-317">
          <h4 className="text-center font-bold text-xl mb-6" data-id="element-318">
            Cada tomo incluye:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-319">
            {inclusions.map((inc, i) => <div key={i} className="flex items-start gap-3" data-id="element-320">
                <CheckCircle2 className="w-5 h-5 text-electric shrink-0 mt-0.5" data-id="element-321" />
                <span className="text-textsecondary text-sm" data-id="element-322">{inc}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}